// src/index.ts
var colors = {
  primary: "#1F4FD8",
  primaryDark: "#163A9E",
  primaryLight: "#E8EEFD",
  secondary: "#0F766E",
  background: "#F5F7FB",
  surface: "#FFFFFF",
  border: "#D9DEE8",
  text: "#172033",
  textMuted: "#5B6478",
  textInverse: "#FFFFFF",
  success: "#157F3D",
  successBg: "#E7F6EC",
  warning: "#9A5B00",
  warningBg: "#FFF4DB",
  danger: "#B42318",
  dangerBg: "#FDECEA",
  info: "#1D5FA8",
  infoBg: "#E6F0FB",
  neutral: "#475467",
  neutralBg: "#EEF1F5"
};
var darkColors = {
  ...colors,
  primary: "#7EA2FF",
  secondary: "#5CCFC0",
  primaryDark: "#A9C0FF",
  primaryLight: "#1B2A4D",
  background: "#0F1420",
  surface: "#171E2E",
  border: "#2A3348",
  text: "#E8ECF4",
  textMuted: "#A3ACBF",
  textInverse: "#0F1420",
  success: "#5FD08A",
  successBg: "#12301F",
  warning: "#F2B84B",
  warningBg: "#35280C",
  danger: "#FF8A80",
  dangerBg: "#3A1514",
  info: "#7CB6F5",
  infoBg: "#142840",
  neutral: "#B8C0CF",
  neutralBg: "#232B3B"
};
var spacing = { xs: 4, sm: 8, md: 12, lg: 16, xl: 24, xxl: 32 };
var radius = { sm: 6, md: 10, lg: 16, pill: 999 };
var fontSize = { xs: 12, sm: 14, md: 16, lg: 18, xl: 22, xxl: 28 };
var fontWeight = { regular: "400", medium: "500", semibold: "600", bold: "700" };
var STATUS_TONE = {
  DRAFT: { fg: "neutral", bg: "neutralBg" },
  UNDER_REVIEW: { fg: "info", bg: "infoBg" },
  APPROVED: { fg: "secondary", bg: "successBg" },
  REJECTED: { fg: "danger", bg: "dangerBg" },
  RETURNED_FOR_CORRECTION: { fg: "warning", bg: "warningBg" },
  CANCELLED: { fg: "neutral", bg: "neutralBg" }
};
var PAYMENT_STATUS_TONE = {
  UNPAID: { fg: "warning", bg: "warningBg" },
  PAID: { fg: "success", bg: "successBg" }
};
function toCssVariables(palette = colors) {
  return Object.entries(palette).map(([k, v]) => `--color-${k.replace(/[A-Z]/g, (m) => `-${m.toLowerCase()}`)}: ${v};`).join("\n");
}
export {
  PAYMENT_STATUS_TONE,
  STATUS_TONE,
  colors,
  darkColors,
  fontSize,
  fontWeight,
  radius,
  spacing,
  toCssVariables
};
